import { render, staticRenderFns } from "./BanksIntegrationsUnavailableTip.vue?vue&type=template&id=73ac67ba&functional=true&"
import script from "./BanksIntegrationsUnavailableTip.vue?vue&type=script&lang=js&"
export * from "./BanksIntegrationsUnavailableTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports